import { NextResponse } from 'next/server';
import type { ApiErrorResponse } from '../interfaces/ApiErrorResponse';

/**
 * @group Functions
 * @summary <blockquote>Handles general server errors and returns a standardized error response.</blockquote>
 * @param error - The server error that occurred
 * @param operation - Description of the operation that failed
 * @returns A NextResponse with standardized error structure
 * @example
 * ```typescript
 * try {
 *   const result = await processData(data);
 * } catch (error) {
 *   return handleServerError(error, 'processing data');
 * }
 * ```
 */
export function handleServerError(error: any, operation: string): NextResponse<ApiErrorResponse> {
  console.error(`Server error during ${operation}:`, error);
  
  return NextResponse.json({
    error: 'Server error',
    details: 'An unexpected error occurred while processing your request.',
    technical: error.message
  }, { status: 500 });
} 